async function addBundleToCart(items) {
    const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        },
        body: JSON.stringify({ items })
    });

    if (!response.ok) {
        const error = await response.json();
        throw new Error(error.description || 'Failed to add product.');
    }

    return await response.json();
} 

function getStoneQuantity() {
    const container = document.querySelector('.personalize-image-main-container');
    return container?.classList.contains('toi-et-moi-Earrings') ? 2 : 1;
}

async function addSavedBundleToCart(saved) {
    const product = window.birthstoneBuilder.mainProduct;
    let metalIndex = null;
    let sizeIndex = null;
    product.options.forEach((optionName, index) => {
        const name = optionName.toLowerCase();
        if (
            name.includes('color') ||
            name.includes('colour') ||
            name.includes('metal') ||
            name.includes('finish')
        ) {
            metalIndex = index + 1;
        }

        if (name.includes('size')) {
            sizeIndex = index + 1;
        }
    });

    const mainVariant = product.variants.find((variant) => {
        if (metalIndex && variant['option' + metalIndex] !== saved.metal) {
            return false;
        }
        if (sizeIndex && variant['option' + sizeIndex] !== saved.size) {
            return false;
        }
        return true;
    });

    if (!mainVariant || !mainVariant.available) {
        return;
    }

    const bundleId = Date.now();
    const stoneQuantity = getStoneQuantity();
    const items = [
        {
            id: Number(mainVariant.id),
            quantity: 1,
            properties: {
                Rectangle: saved.rectangle,
                Pear: saved.pear,
                _bundle_group_id: bundleId,
                _is_main: true
            }
        },
        {
            id: Number(saved.rectangleVariantId),
            quantity: stoneQuantity,
            properties: {
                _addon: 'free',
                _bundle_group_id: bundleId,
                _is_addon: true
            }
        },
        {
            id: Number(saved.pearVariantId),
            quantity: stoneQuantity,
            properties: {
                _addon: 'free',
                _bundle_group_id: bundleId,
                _is_addon: true
            }
        }
    ];

    await addBundleToCart(items);
    document.dispatchEvent(new CustomEvent('cart:build', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) {
        setTimeout(() => {
            cartDrawer.setAttribute('open', '');
        }, 300);
    }
}
 
 document.addEventListener('DOMContentLoaded', function () {

    function showMainImageByMetal(metal) {
        // if (metal !== 'Gold Color' && metal !== 'Silver Color') {
        //     metal = 'Gold Color'
        // }
        const selectedAlt = metal.replace(/\s+/g, "_");

        builder.querySelectorAll('.personalize-main-image img').forEach((img) => {
            img.classList.toggle('hidden', img.alt !== selectedAlt);
        });
    }

    function updateSidebarMetal(metal) {
        const metalLower = metal.toLowerCase();        
        const color = builder.querySelector('.selected-metal-color');
        if (!color) return;
        color.className = 'selected-metal-color';
        if (metalLower === 'gold color') {
            color.classList.add('gold');
        } else if (metalLower === 'silver color') {
            color.classList.add('silver');
        } else {
            color.classList.add('14k');
            color.classList.add('fourteen_karat');
        }
    }

    function updateVariantMessage() {
      const message = builder.querySelector('.builder-variant-message');
      if (!message) return;
      message.classList.remove('show');
      if (builderConfig.hasMetal && !builderState.selections.metal) {
          return;
      }
      if (builderConfig.hasSize && !builderState.selections.size) {
          return;
      }
      const variant = getMainVariant();
      if (!variant || !variant.available) {
        message.classList.add('show');
      }
    }

    function resetBuilder() {
        builderState.selections = {
            metal: null,
            size: null,
            rectangle: null,
            rectangleVariantId: null,
            pear: null,
            pearVariantId: null,
        };

        builder.querySelectorAll('.builder-option.active').forEach(btn=>{
            btn.classList.remove('active');
        });

        builder.querySelectorAll('.builder-sidebar .step-content span').forEach(span=>{
            span.textContent = 'Not Selected';
        });

        const image = builder.querySelector('.builder-main-image');
        if(image){
            image.src = window.birthstoneBuilder.mainProduct.variants[0].featuredImage || image.src;
        }
        if (window.birthstoneBuilder.rectangleProduct?.variants?.length) {
            showRectangleImage(window.birthstoneBuilder.rectangleProduct.variants[0].id);
        }

        if (window.birthstoneBuilder.pearProduct?.variants?.length) {
            showPearImage(window.birthstoneBuilder.pearProduct.variants[0].id);
        }

        const metalColor = builder.querySelector('.selected-metal-color');
        if (metalColor) {
            metalColor.className = 'selected-metal-color hidden';
        }

        builder.querySelectorAll(
            '.selected-rectangle-image, .selected-pear-image'
        ).forEach(img => {
            img.src = '';
            img.classList.add('hidden');
        });
        // if (window.birthstoneBuilder.config.hasMetal) {
        //     showMainImageByMetal(
        //         window.birthstoneBuilder.mainProduct.variants[0].option1
        //     );
        // }
        localStorage.removeItem(STORAGE_KEY);
        updateVariantMessage();
        refreshSidebar();
        showStep(
            Math.min(...Object.values(builderSteps).filter(step=>step>0))
        );
    }

    function saveState() {
        try {
            localStorage.setItem(
                STORAGE_KEY,
                JSON.stringify(builderState.selections)
            );
        } catch (error) {
            if (error.name === 'QuotaExceededError') {
                localStorage.removeItem(STORAGE_KEY);
                try {
                    localStorage.setItem(
                        STORAGE_KEY,
                        JSON.stringify(builderState.selections)
                    );
                } catch (_) {}
            }
        }
    }

    const builder = document.querySelector('.birthstone-builder');
    if (!builder) return;
    if (builder) {
    if (window.innerWidth >= 990) { 
            builder.classList.add('sidebar-open');
        } else {
            builder.classList.remove('sidebar-open');
        }
    }

    const builderConfig = window.birthstoneBuilder.config;
    const builderSteps = window.birthstoneBuilder.steps;
    const panels = builder.querySelectorAll('.builder-step-panel');
    const sidebarSteps = builder.querySelectorAll('.builder-sidebar .builder-step');
    const builderState = {
      currentStep: Math.min(...Object.values(builderSteps).filter(step => step > 0)),
      selections: {
        metal: null,
        size: null,
        rectangle: null,
        rectangleVariantId: null,
        pear: null,
        pearVariantId: null,
      },
    };
    const STORAGE_KEY = window.birthstoneBuilder.productUrl;
    window.personalizeButtonText =
    document.querySelector('.personalize-birthstone-btn span')?.textContent.trim();

    function updatePersonalizeButton() {
        const btn = document.querySelector('.personalize-birthstone-btn');
        const directBtn = document.querySelector('.personalize-direct-cart-btn');

        if (!btn || !directBtn) return;

        const saved = JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}');

        const completed =
            (!builderConfig.hasMetal || saved.metal) &&
            (!builderConfig.hasSize || saved.size) &&
            saved.rectangleVariantId &&
            saved.pearVariantId;

        if (completed) {
            btn.classList.add('product-edited');
            btn.querySelector('span').textContent = 'EDIT PRODUCT';

            directBtn.classList.remove('hidden');
        } else {
            btn.classList.remove('product-edited');
            btn.querySelector('span').textContent =
                window.personalizeButtonText || btn.querySelector('span').textContent;

            directBtn.classList.add('hidden');
        }
    }

  function isStepCompleted(step) {
      if (builderConfig.hasMetal && step === builderSteps.metal) {
          return builderState.selections.metal !== null;
      }
      if (builderConfig.hasSize && step === builderSteps.size) {
          return builderState.selections.size !== null;
      }
      if (step === builderSteps.rectangle) {
          return builderState.selections.rectangle !== null;
      }
      if (step === builderSteps.pear) {
          return builderState.selections.pear !== null;
      }
      return false;
  }

    function refreshSidebar() {
        sidebarSteps.forEach((sidebar) => {
          const step = Number(sidebar.dataset.step);
          sidebar.classList.toggle('active', step === builderState.currentStep);

          const steps = Object.values(builderSteps)
          .filter(step => step > 0)
          .sort((a, b) => a - b);

          const currentIndex = steps.indexOf(step);
          if (
              currentIndex === 0 ||
              isStepCompleted(steps[currentIndex - 1])
          ) {
              sidebar.classList.add('clickable');
          } else {
              sidebar.classList.remove('clickable');
          }
        });

      const addBtn = builder.querySelector('.builder-add-to-bag');
      if (addBtn) {
        let enableButton = isStepCompleted(builderSteps.pear);
        if (enableButton) {
          const mainVariant = getMainVariant();
          enableButton = !!(mainVariant && mainVariant.available);
        }
        addBtn.disabled = !enableButton;
      }
    }

    function showStep(step) {
      builderState.currentStep = step;
      panels.forEach((panel) => {
        panel.classList.toggle('active', Number(panel.dataset.step) === step);
      });
      refreshSidebar();
    }

    // function isSilverMetal() {
    //     const metal = builderState.selections.metal || '';
    //     return metal.toLowerCase().includes('silver');
    // }

    function getSelectedMetalKey() {
        const metal = (builderState.selections.metal || '').toLowerCase();
        
        if (metal.includes('silver')) {
            return 'silver';
        }

        if (metal.includes('14k')) {
            return '14k';
        }
        return 'gold';
    }

    function getMainVariant() {
      const product = window.birthstoneBuilder.mainProduct;
      if (!product) return null;
      const metal = builderState.selections.metal;
      const size = builderState.selections.size;
      let metalIndex = null;
      let sizeIndex = null;

      product.options.forEach((optionName, index) => {
        const name = optionName.toLowerCase();
        if (name.includes('color') || name.includes('colour') || name.includes('metal') || name.includes('finish')) {
          metalIndex = index + 1;
        }

        if (name.includes('size')) {
          sizeIndex = index + 1;
        }
      });
      return product.variants.find((variant) => {
          if (metalIndex && variant['option' + metalIndex] !== metal) {
              return false;
          }
          if (sizeIndex && variant['option' + sizeIndex] !== size) {
              return false;
          }
          return true;
      });
    }

    function preloadStoneImages() {
        const images = builder.querySelectorAll(
            '.builder-rectangle-image, .builder-pear-image'
        );

        images.forEach((img) => {
            if (!img.src) return;

            const preload = new Image();
            preload.src = img.src;
        });
    }

    function showRectangleImage(variantId) {
        // const metal = isSilverMetal() ? 'silver' : 'gold';
        const metal = getSelectedMetalKey();

        const images = builder.querySelectorAll('.builder-rectangle-image');

        images.forEach((img) => {
            img.classList.add('hidden');
        });

        const image = builder.querySelector(
            '.builder-rectangle-image[data-id="' +
            variantId +
            '"][data-metal="' +
            metal +
            '"]'
        );

        if (image) {
            image.classList.remove('hidden');
        }
    }

    function updateSidebarRectangle(variantId) {
        // const metal = isSilverMetal() ? 'silver' : 'gold';
        const metal = getSelectedMetalKey();

        const previewImage = builder.querySelector(
            '.builder-rectangle-image[data-id="' +
            variantId +
            '"][data-metal="' +
            metal +
            '"]'
        );

        const sidebarImage = builder.querySelector(
            '.selected-rectangle-image'
        );

        if (!previewImage || !sidebarImage) return;

        sidebarImage.src = previewImage.src;
        sidebarImage.alt = '';
        sidebarImage.classList.remove('hidden');
    }

    function showPearImage(variantId) {
        // const metal = isSilverMetal() ? 'silver' : 'gold';
        const metal = getSelectedMetalKey();

        const images = builder.querySelectorAll('.builder-pear-image');

        images.forEach((img) => {
            img.classList.add('hidden');
        });

        const image = builder.querySelector(
            '.builder-pear-image[data-id="' +
            variantId +
            '"][data-metal="' +
            metal +
            '"]'
        );

        if (image) {
            image.classList.remove('hidden');
        }
    }

    function updateSidebarPear(variantId) {
        // const metal = isSilverMetal() ? 'silver' : 'gold';
        const metal = getSelectedMetalKey();

        const previewImage = builder.querySelector(
            '.builder-pear-image[data-id="' +
            variantId +
            '"][data-metal="' +
            metal +
            '"]'
        );

        const sidebarImage = builder.querySelector(
            '.selected-pear-image'
        );

        if (!previewImage || !sidebarImage) return;

        sidebarImage.src = previewImage.src;
        sidebarImage.alt = '';
        sidebarImage.classList.remove('hidden');
    }

    function restoreFromUrl() {
        const params = new URLSearchParams(window.location.search);
        const metal = params.get('metal');
        const size = params.get('size');
        const rectangle = params.get('rectangle');
        const pear = params.get('pear');

        if (!metal && !size && !rectangle && !pear) {
            return false;
        }
        if (metal) {
            builder.querySelector(
                '.builder-option[data-metal="' + CSS.escape(metal) + '"]'
            )?.click();
        }
        if (size) {
            builder.querySelector(
                '.builder-option[data-size="' + CSS.escape(size) + '"]'
            )?.click();
        }
        if (rectangle) {
            builder.querySelector(
                '.builder-option[data-id="' + rectangle + '"]'
            )?.click();
        }
        if (pear) {
            builder.querySelector(
                '.builder-option[data-id="' + pear + '"]'
            )?.click();
        }
        return true;
    }

    function restoreState() {
        const data = localStorage.getItem(STORAGE_KEY);
        if (!data) return;
        const saved = JSON.parse(data);
        builderState.selections = {
            ...builderState.selections,
            ...saved
        };

        panels.forEach((panel) => {
            const step = Number(panel.dataset.step);
            panel.querySelectorAll('.builder-option').forEach((btn) => {
                switch (step) {
                    case builderSteps.metal:
                        if (btn.dataset.metal === saved.metal) {
                            btn.classList.add('active');
                        }
                        break;

                    case builderSteps.size:
                        if (btn.dataset.size === saved.size) {
                            btn.classList.add('active');
                        }
                        break;

                    case builderSteps.rectangle:
                        if (btn.dataset.id == saved.rectangleVariantId) {
                            btn.classList.add('active');
                        }
                        break;

                    case builderSteps.pear:
                        if (btn.dataset.id == saved.pearVariantId) {
                            btn.classList.add('active');
                        }
                        break;
                }

            });

        });

        if (saved.metal) {
            builder.querySelector('.selected-metal').textContent = saved.metal;
            showMainImageByMetal(saved.metal);
            updateSidebarMetal(saved.metal);
        }

        if (saved.size) {
            builder.querySelector('.selected-size').textContent = saved.size;
        }

        if (saved.rectangle) {
            builder.querySelector('.selected-rectangle').textContent = saved.rectangle;
        }

        if (saved.rectangleVariantId) {
            showRectangleImage(saved.rectangleVariantId);
            updateSidebarRectangle(saved.rectangleVariantId);
        }

        if (saved.pear) {
            builder.querySelector('.selected-pear').textContent = saved.pear;
        }

        if (saved.pearVariantId) {
            showPearImage(saved.pearVariantId);
            updateSidebarPear(saved.pearVariantId);
        }
        updateVariantMessage();
        refreshSidebar();
        updatePersonalizeButton();
    }

    builder.addEventListener('click', function (e) {
      
      const closeSidebar = e.target.closest('.builder-sidebar-close');
      if (closeSidebar) {
          builder.classList.remove('sidebar-open');
          return;
      }

      const overlay = e.target.closest('.builder-sidebar-overlay');
      if (overlay) {
          builder.classList.remove('sidebar-open');
          return;
      }

      const clear = e.target.closest('.builder-clear-all');
      if(clear){
          resetBuilder();
          return;
      }

      // NEXT
        const next = e.target.closest('.builder-next');
        if (next) {
            if (!isStepCompleted(builderState.currentStep)) {
                return;
            }
            const steps = Object.values(builderSteps)
                .filter(step => step > 0)
                .sort((a, b) => a - b);
            const currentIndex = steps.indexOf(builderState.currentStep);
            if (currentIndex !== -1 && currentIndex < steps.length - 1) {
                showStep(steps[currentIndex + 1]);
            }
            return;
        }

        // PREVIOUS
        const prev = e.target.closest('.builder-prev');
        if (prev) {
            const steps = Object.values(builderSteps)
                .filter(step => step > 0)
                .sort((a, b) => a - b);
            const currentIndex = steps.indexOf(builderState.currentStep);
            if (currentIndex > 0) {
                showStep(steps[currentIndex - 1]);
            }
            return;
        }

      /* ======================
       OPTION SELECT
    ====================== */

      const option = e.target.closest('.builder-option');
      if (option) {
        const panel = option.closest('.builder-step-panel');
        const step = Number(panel.dataset.step);

        panel.querySelectorAll('.builder-option').forEach((btn) => {
          btn.classList.remove('active');
        });
        option.classList.add('active');

        const value = option.textContent.trim();
        switch (step) {
            case builderSteps.metal:
                builderState.selections.metal = value;

                showMainImageByMetal(value);
                updateSidebarMetal(value);

                // Rectangle preview
                const rectangleVariantId =
                    builderState.selections.rectangleVariantId ||
                    window.birthstoneBuilder.rectangleProduct?.variants?.[0]?.id;

                if (rectangleVariantId) {
                    showRectangleImage(rectangleVariantId);

                    // Only update sidebar if a stone is actually selected
                    if (builderState.selections.rectangleVariantId) {
                        updateSidebarRectangle(rectangleVariantId);
                    }
                }

                // Pear preview
                const pearVariantId =
                    builderState.selections.pearVariantId ||
                    window.birthstoneBuilder.pearProduct?.variants?.[0]?.id;

                if (pearVariantId) {
                    showPearImage(pearVariantId);

                    // Only update sidebar if a stone is actually selected
                    if (builderState.selections.pearVariantId) {
                        updateSidebarPear(pearVariantId);
                    }
                }

                break;

            case builderSteps.size:
                builderState.selections.size = value;
                break;

            case builderSteps.rectangle:
                builderState.selections.rectangle = value;
                builderState.selections.rectangleVariantId = option.dataset.id;
                showRectangleImage(option.dataset.id);
                updateSidebarRectangle(option.dataset.id);
                break;

            case builderSteps.pear:
                builderState.selections.pear = value;
                builderState.selections.pearVariantId = option.dataset.id;
                showPearImage(option.dataset.id);
                updateSidebarPear(option.dataset.id);
                break;
        }

        const sidebarValue = builder.querySelector('.builder-step[data-step="' + step + '"] .step-content span');
        if (sidebarValue) {
          sidebarValue.textContent = value;
        }
        updateVariantMessage();
        refreshSidebar();
        saveState();
        updatePersonalizeButton();
        return;
      }

      /* ======================
       ADD TO BAG
    ====================== */

    //   const addToBag = e.target.closest('.builder-add-to-bag');
    //   if (addToBag) {
    //     if (!isStepCompleted(builderSteps.pear)) return;
    //     const mainVariant = getMainVariant();
    //     if (!mainVariant || !mainVariant.available) {
    //       updateVariantMessage();
    //       return;
    //     }

    //     console.log('------------------------------');
    //     console.log('Main Product Variant ID:', mainVariant?.id);
    //     console.log('Rectangle Variant ID:', builderState.selections.rectangleVariantId);
    //     console.log('Pear Variant ID:', builderState.selections.pearVariantId);
    //     console.log(builderState.selections);
    //     console.log('------------------------------');
    //     return;
    //   }

    const addToBag = e.target.closest('.builder-add-to-bag');
    if (addToBag) {
        if (!isStepCompleted(builderSteps.pear)) return;
        const mainVariant = getMainVariant();

        if (!mainVariant || !mainVariant.available) {
            updateVariantMessage();
            return;
        }

        addToBag.disabled = true;
        addToBag.classList.add('loading');
        const bundleId = Date.now();
        const stoneQuantity = getStoneQuantity();

        const items = [
            {
                id: Number(mainVariant.id),
                quantity: 1,
                properties: {
                    Rectangle: builderState.selections.rectangle,
                    Pear: builderState.selections.pear,
                    _bundle_group_id: bundleId,
                    _is_main: true
                }
            },
            {
                id: Number(builderState.selections.rectangleVariantId),
                quantity: stoneQuantity,
                properties: {
                    _addon: 'free',
                    _bundle_group_id: bundleId,
                    _is_addon: true
                }
            },
            {
                id: Number(builderState.selections.pearVariantId),
                quantity: stoneQuantity,
                properties: {
                    _addon: 'free',
                    _bundle_group_id: bundleId,
                    _is_addon: true
                }
            }
        ];

        addBundleToCart(items)
            .then((cartItems) => {
                // console.log('✅ Added to cart');
                // console.log(cartItems);
                
                document.dispatchEvent(new CustomEvent('cart:build', { bubbles: true }));
                document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

                const customDrawer = document.querySelector('.custom_drawer');
                document.body.classList.remove('custom_drwer');
                if (customDrawer) {
                    customDrawer.classList.add('hidden');
                }
                const cartDrawer = document.querySelector('cart-drawer');
                if (cartDrawer) {
                    setTimeout(() => {
                        cartDrawer.setAttribute('open', '');
                    }, 300);
                }
            })
            .catch((error) => {
                console.error(error);
            })
            .finally(() => {
                addToBag.disabled = false;
                addToBag.classList.remove('loading');
            });

        return;
    }
    

      /* ======================
       SIDEBAR CLICK
    ====================== */

      const sidebar = e.target.closest('.builder-sidebar .builder-step');
      if (sidebar) {
        const step = Number(sidebar.dataset.step);
        const steps = Object.values(builderSteps)
        .filter(step => step > 0)
        .sort((a, b) => a - b);

        const currentIndex = steps.indexOf(step);
        if (
            currentIndex === 0 ||
            step === builderState.currentStep ||
            isStepCompleted(steps[currentIndex - 1])
        ) {
            showStep(step);
            if (window.innerWidth < 990) {
                builder.classList.remove('sidebar-open');
            }
        }
        return;
      }
    });
    showStep(Math.min(...Object.values(builderSteps).filter(step => step > 0)));

    preloadStoneImages();

    if (!restoreFromUrl()) {
        restoreState();
    }

    updatePersonalizeButton();

    document.addEventListener('click', async function (e) {
        const share = e.target.closest('.builder-share');
        if (!share) return;
        const selections = builderState.selections;
        const url = new URL(window.birthstoneBuilder.shopUrl + window.birthstoneBuilder.productUrl);
        if (selections.metal) {
            url.searchParams.set('metal', selections.metal);
        }

        if (selections.size) {
            url.searchParams.set('size', selections.size);
        }

        if (selections.rectangleVariantId) {
            url.searchParams.set('rectangle', selections.rectangleVariantId);
        }

        if (selections.pearVariantId) {
            url.searchParams.set('pear', selections.pearVariantId);
        }

        console.log(url.toString());

        try {
            await navigator.clipboard.writeText(url.toString());
            const toast = document.querySelector('.builder-toast');
            if (toast) {
                toast.classList.add('show');
                clearTimeout(window.builderToastTimer);
                window.builderToastTimer = setTimeout(() => {
                    toast.classList.remove('show');
                }, 2000);
            }
        } catch (err) {
            console.error(err);
        }
    });

    const openSidebar = document.querySelector('.builder-sidebar-toggle');
    if (openSidebar) {
    openSidebar.addEventListener('click', function () {
        document.querySelector('.birthstone-builder').classList.add('sidebar-open');
    });
    }

    const directCartBtn = document.querySelector('.personalize-direct-cart-btn');
    if (directCartBtn) {
        directCartBtn.addEventListener('click', async function () {
            const saved = JSON.parse(
                localStorage.getItem(STORAGE_KEY) || '{}'
            );
            const completed =
                (!builderConfig.hasMetal || saved.metal) &&
                (!builderConfig.hasSize || saved.size) &&
                saved.rectangleVariantId &&
                saved.pearVariantId;

            if (!completed) return;
            directCartBtn.disabled = true;
            directCartBtn.classList.add('loading');
            try {
                await addSavedBundleToCart(saved);

            } catch (e) {
                console.error(e);
            } finally {
                directCartBtn.disabled = false;
                directCartBtn.classList.remove('loading');
            }
        });
    }
  });